import NavigationBarControl from '../../../lib/ui/NavigationBarControl'
import FileControl from '../../../lib/ui/FileControl'

export default class Import {
  constructor (element, args) {
    this.element = element
    this.args = args

    this.render(element)
  }

  render (element) {
    let fragment = document.createDocumentFragment()

    this.renderNavigation(fragment)

    let div = document.createElement('div')
    div.className = 'viewport'

    let p = document.createElement('p')
    p.innerHTML = 'Geef hieronder het import bestand op.'
 
    div.appendChild(p)

    this.renderForm(div)

    fragment.appendChild(div)

    let button = document.createElement('button')
    button.innerHTML = 'Importeer bestand'
    button.onclick = this.onimport

    fragment.appendChild(button)

    element.appendChild(fragment)
  }

  renderForm (element) {
    let fieldsetFile = document.createElement('fieldset')
    let legendFile = document.createElement('legend')
    legendFile.innerHTML = 'Importeren'
    fieldsetFile.appendChild(legendFile)

    this.file = new FileControl(fieldsetFile, {label: 'Import bestand'})
  
    element.appendChild(fieldsetFile)
  }

  renderNavigation (element) {
    new NavigationBarControl(element, {
      title: 'Gegevens importeren',
      leftHandButtons: [{
        onclick: () => {
          history.back()
        },
        icon: '\ue00d'
      }]
    })
  }

  onimport () {    
    if (this.file.input.files.length === 0) {
      alert('Kies eerst een import bestand.')
      return
    }

    let reader = new FileReader();
    reader.onload = () => {
      let data = JSON.parse(reader.result)
      let promises = []

      if (data.people) {
        data.people.forEach((item) => {
          promises.push(window.PRIM.dataAccess.put(item))          
        })
      }

      Promise.all(promises).then(() => {
        alert(promises.length + ' item(s) zijn geimporteerd.')
      }, () => {
        alert('Er is een fout opgetreden. Niet alle ' + promises.length + ' item(s) zijn geimporteerd.')
      })
    }
    reader.onerror = () => {
      alert('Er is een fout opgetreden. Het bestand kon niet worden gebruikt als import bestand.')
    }
    reader.readAsText(this.file.input.files[0])
  }
}



// WEBPACK FOOTER //
// ./js/modules/import/action/Import.js